module.exports = __webpack_public_path__ + "img/billing-address-icon.58108961.svg";